module.exports = __webpack_public_path__ + "static/media/np.805dc8be.svg";